import { Alert, AlertTitle, AppBar, Box, Breadcrumbs, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack, TextField, Toolbar, Typography, lighten } from "@mui/material";
import FolderItem from "./FolderItem";
import FileItem from "./FileItem";
import { useEffect, useState } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import { Link, useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { DeleteFileFolderContext, PathBreadCrumbContext } from "./HrPolicies";
import { useContext } from "react";
import { useCallback } from "react";
import { checkSpecialChar } from "../utilities/FormValidation";

const FileList = (props) => {
    const [folders, setFolders] = useState(props.folders);
    const [files, setFiles] = useState(props.files);
    const [pathBreadCrumb, setPathBreadCrumb] = useContext(PathBreadCrumbContext);
    const [error, setError] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [deletedMsg, setDeletedMsg] = useContext(DeleteFileFolderContext);
    const [folderName, setFolderName] = useState();
    const [folderValid, setFolderValid] = useState();
    const [fileName, setFileName] = useState();
    const [file, setFile] = useState();
    const [snackState, setSnackState] = useState(false);
    const [addFolder, setAddFolder] = useState(false);
    const [addFile, setAddFile] = useState(false);
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
    const params = useParams()
    const libraryStructuresUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.hrLibraryStructures}`;
    const hrPolicyDocuments = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.hrPolicyDocuments}`;
    const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileUpload}`;
    const libraryUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.libraryStructure}`;

    const handleAddFileUpdate = () => {
        setFileName("");
        setFile([]);
        if (error) {
            setError('');
        }
    }

    const headerButtons = () => {
        return <>
            {(token?.scope.includes('ROLE_MD') || token?.scope.includes('ROLE_HR')) &&
                <>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={(e) => setAddFolder(true)}
                    >
                        <FuseSvgIcon>heroicons-outline:plus-circle</FuseSvgIcon> Add Folder
                    </Button>
                    {params.id && <Button
                        variant="contained"
                        color="warning"
                        onClick={(e) => {
                            setAddFile(true);
                            handleAddFileUpdate(e);
                        }}
                    >
                        <FuseSvgIcon>heroicons-outline:plus-circle</FuseSvgIcon> Add File
                    </Button>}
                </>}
        </>;
    }

    useEffect(() => {
        setSnackState(false)
        setFolders(props.folders)
        setFiles(props.files);
        if (props.deletedMsg) {
            setTimeout(() => {
                setSuccessMsg(props.deletedMsg)
                setSnackState(true);                
                setTimeout(() => {
                    setDeletedMsg('')
                },1000)
            },100)
        }
    }, [props])

    const handleAddFolder = async () => {
        setSnackState(false)
        if (folderName) {
            let obj = {
                name: folderName,
                parent: null
            }

            if (params.id) {
                obj = { ...obj, parent: libraryStructuresUrl + `/${params.id}` }
            }
            try {
                const created = await OAuthService.addData(libraryStructuresUrl, obj);
                if (created.data) {
                    setSuccessMsg("Folder Created successfully");
                    setSnackState(true);
                    if (params.id) {

                        const alllist = await OAuthService.getList(libraryUrl + '/findChild/' + params.id);
                        if (alllist?.data) {
                            alllist?.data.map((data) => {
                                if (data?.subFolder) {
                                    setFolders(data?.subFolder)
                                }
                                if (data?.files) {
                                    setFiles(data?.files)
                                }
                            })
                        }
                    } else {
                        const alllist = await OAuthService.getList(libraryUrl + '/getLibraryStructure');
                        if (alllist?.data) {
                            setFolders(alllist?.data);
                        }
                    }
                }
                setAddFolder(false);

            } catch (error) {

            }
        }

    }
    const handleAddFile = async () => {
        setSnackState(false)
        if (params.id) {
            const formData = new FormData();
            formData.append('file', file);
            try {
                setError('')
                const uploadData = await OAuthService.uploadFile(uploadUrl, formData);
                if (uploadData?.data) {
                    if (uploadData.data.error) {
                        setError(uploadData.data.error)
                        setAddFile(false)
                    } else {
                        let obj = {
                            fileName: file.name,
                            fileUrl: uploadData?.data?.downloadUri,
                            fileSize: uploadData?.data?.size,
                            libraryStructure: params.id.toString(),
                        }
                        const filedata = await OAuthService.addData(hrPolicyDocuments, obj);
                        if (filedata?.data) {
                            setSuccessMsg("File Uploaded successfully");
                            setSnackState(true);
                            setTimeout(() => {
                                setSuccessMsg("")
                                setSnackState(false);
                            },2000)
                            const alllist = await OAuthService.getList(libraryUrl + '/findChild/' + params.id);
                            if (alllist?.data) {
                                alllist?.data.map((data) => {
                                    if (data?.subFolder) {
                                        setFolders(data?.subFolder)
                                    }
                                    if (data?.files) {
                                        setFiles(data?.files)
                                    }
                                })
                            }
                        }
                        setAddFile(false)
    
                    }
                }
            } catch (error) {
                setError(error?.response?.data?.errorMessage || error.message)
            }
           
        }
    }

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];
        setFileName(file.name);
        setFile(file);
    }

    const removeDocument = () => {
        setFileName("");
        setFile([]);
    }

    const breadCrumbs = useCallback(() => {

        return <>{pathBreadCrumb.length > 1 && <Breadcrumbs
            aria-label="breadcrumb"
            className="mx-12"
            separator={<NavigateNextIcon fontSize="small" />}
        >
            {pathBreadCrumb.map((item, index) =>
                index + 1 === pathBreadCrumb.length ? (
                    <Typography key={index}>{item?.name}</Typography>
                ) : (
                    <Link key={index} color="text.primary" to={`/hrPolicies/${item.id}`}>
                        {item?.name}
                    </Link>
                )
            )}
        </Breadcrumbs>}</>
    }, [pathBreadCrumb])

    return (
        <div>
            <ListPageHeader
                componentName="HrPolicies"
                pageName="HR Policies"
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                headerInputFields={headerButtons()}
                pagination={false}
                breadCrumbs={breadCrumbs()}
            />
            <div className="p-32 overflow-scroll">
                {folders.length > 0 && (
                    <Box
                        className="p-16 w-full rounded-16 mb-24 border"
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light'
                                    ? lighten(theme.palette.background.default, 0.4)
                                    : lighten(theme.palette.background.default, 0.02),
                        }}
                    >

                        <div className="flex flex-wrap -m-8 mt-8">
                            {folders.map((item) => (
                                <FolderItem key={item.id} item={item} />
                            ))}
                        </div>
                    </Box>
                )}

                {files.length > 0 && (
                    <Box
                        className="p-16 w-full rounded-16 mb-24 border"
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light'
                                    ? lighten(theme.palette.background.default, 0.4)
                                    : lighten(theme.palette.background.default, 0.02),
                        }}
                    >

                        <div className="flex flex-wrap -m-8 mt-8">
                            {files.map((item) => (
                                <FileItem key={item.id} item={item} />
                            ))}
                        </div>
                    </Box>
                )}

                <Dialog
                    open={addFolder}
                    handleClose={(e) => setAddFolder(false)}
                    fullWidth={true}
                    maxWidth={'sm'}
                >
                    <AppBar position="static">
                        <Toolbar className="flex w-full justify-between">
                            <Typography variant="subtitle1" color="inherit">
                                Create New Folder</Typography>
                            <Button onClick={() => setAddFolder(false)}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                        </Toolbar>
                    </AppBar>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <Grid item className="self-center "><label>New Folder Name: </label></Grid>
                            <Grid item >
                                <TextField
                                    name="folderName"
                                    value={folderName}
                                    helperText={folderValid}
                                    onChange={(e) => { setFolderName(e.target.value); setFolderValid(checkSpecialChar(e.target.value)) }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions
                        sx={{ background: "#373c42" }}>
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={handleAddFolder}
                            disabled={(folderName && !folderValid) ? false : true}
                        >
                            <FuseSvgIcon>heroicons-outline:document</FuseSvgIcon>
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={addFile}
                    handleClose={(e) => setAddFile(false)}
                    fullWidth={true}
                    maxWidth={'sm'}
                >
                    <AppBar position="static">
                        <Toolbar className="flex w-full justify-between">
                            <Typography variant="subtitle1" color="inherit">Upload File</Typography>
                            <Button onClick={() => setAddFile(false)}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                        </Toolbar>
                    </AppBar>
                    <DialogContent dividers>
                        {error && (
                            <Alert severity="error" className="mb-16">
                                <AlertTitle>Error</AlertTitle>
                                {error}
                            </Alert>
                        )}
                        {!fileName ?
                            <Stack className='w-full mb-16'>
                                <Box className='flex justify-center items-center'
                                    sx={{

                                        height: 180,
                                        border: '1px dotted grey',
                                    }}
                                >
                                    <CloudUploadIcon fontSize={'large'} /><Typography className='ml-12' >Upload your File</Typography>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        color="warning"
                                        className='ml-12'
                                    >
                                        <input hidden type="file"
                                            onChange={(e) => handleDocumentChange(e)}
                                            accept=".pdf,.doc"
                                        />
                                        <Typography color="black">Browse</Typography>
                                    </Button>
                                </Box>
                            </Stack>
                            :
                            <Stack className='w-full mb-16'>
                                <Box
                                    className='flex justify-between'
                                >
                                    <Grid className='flex'>
                                        <div>
                                            <FileCopyIcon fontSize={'large'} color="warning" className=' mt-20' />
                                        </div>
                                        <div>
                                            <Typography fontSize={'large'} className='ml-12 mt-20' >{fileName}</Typography>

                                        </div>
                                    </Grid>
                                    <Grid>
                                        <FuseSvgIcon className='mt-20 w-32 h-32 cursor-pointer' onClick={() => removeDocument()}>heroicons-outline:x</FuseSvgIcon>
                                    </Grid>
                                </Box>
                            </Stack>
                        }
                    </DialogContent>
                    <DialogActions sx={{ background: "#373c42" }}>
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={handleAddFile}
                        >
                            <FuseSvgIcon>heroicons-outline:document</FuseSvgIcon>
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div >
    );
}

export default FileList